// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1cmvr","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__Ef1zQ"};